export default __webpack_public_path__ + "static/media/kredit.a08dafde.ttf";